import { Station } from '@mi-front/core';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useStatusViewContext } from '../../../context/StatusViewContext';
import { FavoriteStationToggle } from '../favorites/FavoriteStationToggle';
import { StreamerBoxStatus } from '../streamer-box/StreamerBoxStatus';
import { StatusAvatar } from './StatusAvatar';
import { StatusIndicator } from './StatusIndicator';

interface Props {
  readonly station: Station;
  readonly isOnline: boolean;
}

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

/**
 * Header component for the Status card that displays station information,
 * favorite toggle, status indicator, and status badge.
 */
export function StatusHeader(p: Props) {
  const { station, isOnline } = p;
  const { compact } = useStatusViewContext();

  return (
    <Wrapper>
      <StatusAvatar station={station} isOnline={isOnline} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: compact ? 'auto' : '300px',
          flex: compact ? 1 : 'none',
          minWidth: 0, // Allow shrinking in compact mode
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
          }}
        >
          <Typography
            component="div"
            sx={{
              display: 'inline-block',
              margin: compact ? '0 0.5rem' : '0 1rem',
              color: 'black',
              fontSize: compact ? '1rem' : '1.5rem',
              fontWeight: 'bold',
              lineHeight: compact ? '1.25rem' : '1.75rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {station.name}
          </Typography>
          <FavoriteStationToggle stationId={station.id} />
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          minWidth: compact ? 'auto' : '7.5rem',
          marginLeft: 'auto',
          alignItems: 'center',
          gap: compact ? 0.5 : 1,
        }}
      >
        <StreamerBoxStatus stationId={station.id} compact={compact} />
        <StatusIndicator isOnline={isOnline} compact={compact} />
      </Box>
    </Wrapper>
  );
}
